import { useEffect, useState } from 'react'

const CONSENT_COOKIE = 'cookieyes-consent'

// Parse the CookieYes consent cookie (e.g. "necessary:yes,advertisement:no")
// into a map of category -> boolean.
export function readConsent() {
  if (typeof document === 'undefined') return {}

  const entry = document.cookie
    .split('; ')
    .find(row => row.indexOf(`${CONSENT_COOKIE}=`) === 0)

  if (!entry) return {}

  const value = decodeURIComponent(entry.slice(CONSENT_COOKIE.length + 1))

  return value.split(',').reduce((acc, pair) => {
    const [key, val] = pair.split(':')
    if (key) acc[key.trim()] = val === 'yes'
    return acc
  }, {})
}

// Returns whether the visitor has consented to the given CookieYes category.
// Re-evaluates when CookieYes broadcasts a consent change, so gated content
// can appear/disappear without a full page reload.
export default function useConsent(category) {
  const [granted, setGranted] = useState(false)

  useEffect(() => {
    const update = () => setGranted(readConsent()[category] === true)

    update()

    document.addEventListener('cookieyes_consent_update', update)
    return () =>
      document.removeEventListener('cookieyes_consent_update', update)
  }, [category])

  return granted
}
